import { useApi } from '@/api'

export const useBrandMemoryResource = () => {
  const api = useApi()
  const brandOf = (organizationId: string, brandId: string) => api.api.v1.organizations({ organizationId }).brands({ brandId })

  return {
    getBrandMemory: (organizationId: string, brandId: string) => brandOf(organizationId, brandId).memory.get(),
    delBrandMemoryFact: (organizationId: string, brandId: string, factId: string) =>
      brandOf(organizationId, brandId).memory({ factId }).delete()
  }
}
